import React from 'react';
import { formatPhone } from 'App/utils';
import { financialAssistanceReferralDetailsPropType } from './types';
import { ReviewSectionStyle } from 'App/components/EHR/styles';

const DeniedFAReviewContent = ({ financialAssistanceReferralDetails }) => {
    return (
        <div>
            <ReviewSectionStyle>
                <strong>Referral Details</strong>
                <div>Status: {financialAssistanceReferralDetails.status}</div>
                <div>
                    Did the patient file an application {financialAssistanceReferralDetails.fileApplication?.id || '--'}
                </div>
                <div>Selected program: {financialAssistanceReferralDetails.programName || '--'}</div>

                <div>
                    Follow Up Phone Number: {formatPhone(financialAssistanceReferralDetails.followUpPhone) || '--'}
                </div>

                <div>Denial Reason: {financialAssistanceReferralDetails?.denialReason?.name || '--'}</div>
                <div>Notes: {financialAssistanceReferralDetails.notes || '--'}</div>
            </ReviewSectionStyle>
        </div>
    );
};

DeniedFAReviewContent.propTypes = {
    financialAssistanceReferralDetails: financialAssistanceReferralDetailsPropType.isRequired,
};

export default DeniedFAReviewContent;
